import { render, staticRenderFns } from "./carrierselector.vue?vue&type=template&id=68283440"
import script from "./carrierselector.vue?vue&type=script&lang=js"
export * from "./carrierselector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports